import { useCallback } from 'react';

type UseAssistantDraftsParams = {
  setAssistantSaveState: React.Dispatch<React.SetStateAction<Record<string, { status: 'idle' | 'saving' | 'deleting' | 'error'; message: string | null }>>>;
};

type AssistantSaveStatePatch = Partial<{ status: 'idle' | 'saving' | 'deleting' | 'error'; message: string | null }>;

export function useAssistantDrafts({
  setAssistantSaveState,
}: UseAssistantDraftsParams) {
  const updateAssistantSaveState = useCallback((key: string, patch: AssistantSaveStatePatch) => {
    setAssistantSaveState((prev) => {
      const current = prev[key] ?? { status: 'idle', message: null };
      return {
        ...prev,
        [key]: {
          ...current,
          ...patch,
        },
      };
    });
  }, [setAssistantSaveState]);

  return {
    updateAssistantSaveState,
  };
}
